import { createSlice } from "@reduxjs/toolkit";

export const ChatSlice = createSlice({
  name: "chat",
  initialState: {
    chatList: [],
    messageList: [],
    chatType: "chats",
    groupChatToggle: false,
    isChannel: false,
    chatSearch: null,
    activeChatId: null,
    activeUser: null,
    responsiveChat: false,
    chatLoading: false,
  },
  reducers: {
    setChatList: (state, action) => {
      state.chatList = action.payload;
    },
    setIsChannel: (state, action) => {
      state.isChannel = action.payload;
    },
    setChatLoading: (state, action) => {
      state.chatLoading = action.payload;
    },
    setChatType: (state, action) => {
      state.chatType = action.payload;
    },
    setChatSearch: (state, action) => {
      state.chatSearch = action.payload;
    },
    setGroupChatToggle: (state, action) => {
      state.groupChatToggle = action.payload;
    },
    setMessageList: (state, action) => {
      state.messageList = action.payload;
    },
    setActiveChatId: (state, action) => {
      state.activeChatId = action.payload;
    },
    setActiveUser: (state, action) => {
      state.activeUser = action.payload;
    },
    setResponsiveChat: (state, action) => {
      state.responsiveChat = action.payload;
    },
  },
});

export const {
  setChatLoading,
  setChatList,
  setMessageList,
  setChatSearch,
  setGroupChatToggle,
  setChatType,
  setActiveChatId,
  setResponsiveChat,
  setActiveUser,
  setIsChannel,
} = ChatSlice.actions;

export default ChatSlice.reducer;
